<footer class="bg-dark text-white">
  <div class="container py-3">
    <div class="row justify-content-center text-center">
      <div class="col-md-8 col-lg-8 mb-2 mb-md-0 text-center">
        <img src="wyvern-horizontal.svg" alt="Wyvern" class="img-fluid col-2 px-2 py-2">
        <h5 class="font-size-16">LIVE NOT IN FEAR</h5>
        <p class="font-size-12">© 2025 Wyvern Weaponry. All rights reserved.</p>
      </div>
    </div>
  </div>
</footer>
